import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { cloneObject } from '../../../common/utils';
import { allowedSelectOptionTypes } from '../../elements/CustomInput';
import { UnorderedList, allowedUnorderedListProps } from '../UnorderedList';
import InteractiveSelectListItem from './_InteractiveSelectListItem';

const InteractiveSelectList = React.forwardRef((props, passedRef) => {
  const {
    htmlAttributes = {},
    options,
    onSelect,
    setOptionTitle
  } = props;

  const refUnorderedList = passedRef || useRef();
  const { className } = htmlAttributes;
  const finalClassNames = ['interactive-select-list'];
  const listProps = cloneObject(props, {}, [
    'classNames',
    'onSelect',
    'options',
    'setOptionKey',
    'setOptionTitle'
  ]);

  if (className) {
    finalClassNames.push(className);
  }

  listProps.htmlAttributes = {
    ...htmlAttributes,
    className: finalClassNames.join(' ')
  };

  const onKeyUp = (keyName, currentOptionIndex, value) => {
    const keyNameUp = 'ArrowUp';
    const keyNameDown = 'ArrowDown';

    if (keyName === keyNameUp || keyName === keyNameDown) {
      const { current: listElement } = refUnorderedList;
      const lastOptionIndex = options.length - 1;
      let nextOptionIndex = currentOptionIndex;

      if (keyName === keyNameUp) {
        nextOptionIndex = currentOptionIndex > 0 ? currentOptionIndex - 1 : lastOptionIndex;
      }

      if (keyName === keyNameDown) {
        nextOptionIndex = currentOptionIndex < lastOptionIndex ? currentOptionIndex + 1 : 0;
      }

      listElement.querySelector(`[data-index="${nextOptionIndex}"]`).focus();
    }

    if (keyName === 'Enter') {
      onSelect(value);
    }
  };

  return (
    <UnorderedList {...listProps} ref={refUnorderedList}>
      {options.map(({ key, label, value }, index) => {
        const listItemProps = {
          key,
          label,
          value,
          index,
          onSelect,
          onKeyUp,
          setOptionTitle
        };

        return <InteractiveSelectListItem {...listItemProps} />;
      })}
    </UnorderedList>
  );
});

InteractiveSelectList.propTypes = {
  ...allowedUnorderedListProps,
  onSelect: PropTypes.func.isRequired,
  setOptionTitle: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType({
      key: PropTypes.string.isRequired,
      ...allowedSelectOptionTypes
    })
  ).isRequired
};

export default InteractiveSelectList;